const DEBOUNCED_HANDLER_DELAY = 100;
const DESKTOP_MAX_CONTENT_WIDTH = 1200;
const LOCALE_CODE_REGEX = /^(?:\/\w+)?\/(\w+)\/(\w+)/;
const BAZAAR_VOICE_URL = 'https://api.bazaarvoice.com/data/statistics.json';
const REVIEW_SECTION_ANCHOR = '#pdp-reviews';
const SDL_HEADER_SELECTOR = '.js-header-global .js-header';
const SDL_HEADER_SELECTOR_APC = '.js-header-global .js-header-apc';
const SDL_REDESIGN_HEADER_SELECTOR = '.se2--header-se .se2--header-se--common-part';
const siteType = {
    B2B: 'b2b',
    B2C: 'b2c',
};
const b2cSiteTypeURLPrefix = 'home';
const rangeBasePath = 'product-range';
const COMMERCIAL_STATUS_MAX_LENGTH = 28;
const TAB_BAR_HEIGHT = 48;
const scrollBehavior = {
    SMOOTH: 'smooth',
    AUTO: 'auto',
};
const SLASH = '/';
var ECommercialStatus;
(function (ECommercialStatus) {
    ECommercialStatus["COMMERCIALIZED"] = "COMMERCIALIZED";
    ECommercialStatus["LEGACY"] = "LEGACY";
    ECommercialStatus["PRECOMMERCIALIZED"] = "PRECOMMERCIALIZED";
    ECommercialStatus["END_OF_COMMERCIALIZATION_ANNOUNCED"] = "END_OF_COMMERCIALIZATION_ANNOUNCED";
})(ECommercialStatus || (ECommercialStatus = {}));
var EPromiseStatus;
(function (EPromiseStatus) {
    EPromiseStatus["PENDING"] = "pending";
    EPromiseStatus["FULFILLED"] = "fulfilled";
    EPromiseStatus["REJECTED"] = "rejected";
    EPromiseStatus["SETTLED"] = "settled";
})(EPromiseStatus || (EPromiseStatus = {}));
const sustainabilityGroupNameAtg = {
    groupExternalLabels: 'group_external_labels_atg',
    sustainabilityGroupDefault: 'sustainability_group_default_atg',
    groupResourcePerformance: 'group_resource_performance_atg',
    groupChemicalPerformance: 'group_chemical_performance_atg',
};
const sustainabilityGroupNameSpryker = {
    groupExternalLabels: 'group_external_labels',
    sustainabilityGroupDefault: 'sustainability_group_default',
    groupResourcePerformance: 'group_resource_performance',
    groupChemicalPerformance: 'group_chemical_performance',
};
var Protocol;
(function (Protocol) {
    Protocol["HTTP"] = "http";
    Protocol["HTTPS"] = "https";
})(Protocol || (Protocol = {}));
var NUMERIC_SEPARATOR;
(function (NUMERIC_SEPARATOR) {
    NUMERIC_SEPARATOR["COMMA"] = ",";
    NUMERIC_SEPARATOR["DOT"] = ".";
})(NUMERIC_SEPARATOR || (NUMERIC_SEPARATOR = {}));

var EStatus;
(function (EStatus) {
    EStatus["INFORMATIONAL"] = "INFORMATIONAL";
    EStatus["WARNING"] = "WARNING";
    EStatus["ERROR"] = "ERROR";
})(EStatus || (EStatus = {}));
var ENotificationType;
(function (ENotificationType) {
    ENotificationType["PRODUCTS_LIST"] = "PRODUCTS_LIST";
    ENotificationType["SIMPLE_WITH_RELOAD"] = "SIMPLE_WITH_RELOAD";
    ENotificationType["WITH_HTML"] = "WITH_HTML";
})(ENotificationType || (ENotificationType = {}));

var ECtaButtonTypes;
(function (ECtaButtonTypes) {
    ECtaButtonTypes["BUY_ONLINE_BUTTON_REGULAR"] = "BUY_ONLINE_BUTTON_REGULAR";
    ECtaButtonTypes["BUY_ONLINE_BUTTON_APC"] = "BUY_ONLINE_BUTTON_APC";
    ECtaButtonTypes["DOWNLOAD_BUTTON"] = "DOWNLOAD_BUTTON";
    ECtaButtonTypes["NOTIFY_ME_BUTTON"] = "NOTIFY_ME_BUTTON";
    ECtaButtonTypes["ADD_TO_CART_BUTTON"] = "ADD_TO_CART_BUTTON";
    ECtaButtonTypes["PROMOTED_BUTTON"] = "PROMOTED_BUTTON";
    ECtaButtonTypes["PRODUCT_SELECTOR_BUTTON"] = "PRODUCT_SELECTOR_BUTTON";
})(ECtaButtonTypes || (ECtaButtonTypes = {}));
const PRIMARY_BUTTONS = [
    // order matters
    ECtaButtonTypes.NOTIFY_ME_BUTTON,
    ECtaButtonTypes.DOWNLOAD_BUTTON,
    ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_APC,
];
const SECONDARY_BUTTONS = [ECtaButtonTypes.ADD_TO_CART_BUTTON];
const APC_PRIMARY_BUTTONS = [
    // order matters
    ECtaButtonTypes.NOTIFY_ME_BUTTON,
    ECtaButtonTypes.DOWNLOAD_BUTTON,
    ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
    ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
];

/**
 * Buttons
 */
var EAvailabilityType;
(function (EAvailabilityType) {
    EAvailabilityType["ADD_TO_CART"] = "ADD_TO_CART";
    EAvailabilityType["PURCHASE_CD"] = "PURCHASE_CD";
    EAvailabilityType["DISCONTINUED"] = "DISCONTINUED";
})(EAvailabilityType || (EAvailabilityType = {}));
var EApcButtonType;
(function (EApcButtonType) {
    EApcButtonType["ADD_TO_CART"] = "ADD_TO_CART";
    EApcButtonType["DOWNLOAD_BUTTON"] = "DOWNLOAD_BUTTON";
})(EApcButtonType || (EApcButtonType = {}));
const ADD_TO_CART_EXCEPTION_CODES = {
    MAXIMUM_COUNT_WITH_LINK: 'maximumCartCountWithLinkError',
    MAXIMUM_COUNT: 'maximumCartCountError',
};
const PLACEHOLDERS = {
    HOST: '#apcHost#',
    COUNTRY: '#countryCode#',
    LANGUAGE: '#languageCode#',
    FAVORITES_LINK: '{favorites-link}',
    PRODUCT_ID: '#productId#',
    SKUS: '#skus#',
    QTY: '#qty#',
    Chat_CSC_ID: '#Chat_CSC_ID#',
};
const QUERY_LOCALES = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const QUERY_LOCALES_WITHOUT_CHAT = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}`;
const SKU_LIST = `&SKU_List=${PLACEHOLDERS.SKUS}`;
const QTY_LIST = `&qty_list=${PLACEHOLDERS.QTY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const URLS = {
    ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder?${QUERY_LOCALES}`,
    GO_TO_CART: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/cart/shoppingCart.jsp`,
    PRODUCT_AVAILABILITY: `${PLACEHOLDERS.HOST}/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo?partNumbersList=${PLACEHOLDERS.PRODUCT_ID}&${QUERY_LOCALES}`,
    ADD_TO_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToFavorites?${QUERY_LOCALES}`,
    REMOVE_FROM_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromFavorites?${QUERY_LOCALES}`,
    MY_LIST: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/myaccount/myAccountMyList.jsp`,
    CREATE_ACCOUNT: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}&type=reg`,
    SIGN_IN: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}`,
    ADD_TO_CART_SUCCESS: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderSuccess?${QUERY_LOCALES}`,
    ADD_TO_CART_ERROR: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderError?${QUERY_LOCALES}`,
    COMPARISON_ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemsToOrder?${QUERY_LOCALES_WITHOUT_CHAT}${SKU_LIST}${QTY_LIST}`,
};

var EPriceSpiderName;
(function (EPriceSpiderName) {
    EPriceSpiderName["DEFAULT"] = "B2C price spider widget";
    EPriceSpiderName["PRIVATE"] = "B2B price spider widget";
})(EPriceSpiderName || (EPriceSpiderName = {}));
var ECustomerType;
(function (ECustomerType) {
    ECustomerType["CLASSIFICATION1"] = "ATG_CLASSVALUE1";
})(ECustomerType || (ECustomerType = {}));
var EPriceSpiderKey;
(function (EPriceSpiderKey) {
    // PUBLIC and LEGACY keys moved from APC codebase
    EPriceSpiderKey["PUBLIC"] = "5bbf65a04a17ef05e8d8a0ae";
    EPriceSpiderKey["LEGACY"] = "5900be5a8196951772ce423f";
    // PRIVATE key copied from PriceSpider documentation
    EPriceSpiderKey["PRIVATE"] = "65304d2283d990000e23ce8c";
})(EPriceSpiderKey || (EPriceSpiderKey = {}));

var EEvent;
(function (EEvent) {
    EEvent["COMPARE_CONTROL_CLICK"] = "comparatorClick";
    EEvent["COMPARATOR_PRODUCTS_CHANGE"] = "comparatorProductsChange";
})(EEvent || (EEvent = {}));

const myProductsGroupType = {
    SINGLE: 'single',
    GROUP: 'group',
};
// Status of update:
// 'SUCCESS';
// 'ERROR' - when not all products are found and request `allowPartialAdding=false`;
// 'PRODUCTS_UNAVAILABLE' - not found any product in catalog;.
const myProductsResponseStatus = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
Object.assign(Object.assign({}, myProductsResponseStatus), { PRODUCTS_UNAVAILABLE: 'PRODUCTS_UNAVAILABLE' });
Object.assign({}, myProductsResponseStatus);

var ETabType;
(function (ETabType) {
    ETabType["DOCUMENTS"] = "DOCUMENTS";
    ETabType["COMPATIBLE_PRODUCTS"] = "COMPATIBLE_PRODUCTS";
    ETabType["SPECIFICATIONS"] = "SPECIFICATIONS";
    ETabType["EPDS"] = "EPDS";
    ETabType["DDC_DOCUMENTS"] = "DDC_DOCUMENTS";
    ETabType["DDC_SOFTWARE"] = "DDC_SOFTWARE";
    ETabType["SOFTWARE_CAROUSEL"] = "SOFTWARE_CAROUSEL";
    ETabType["LIFECYCLE_CAROUSEL"] = "LIFECYCLE_CAROUSEL";
    ETabType["EXPLORE_CAROUSEL"] = "EXPLORE_CAROUSEL";
    ETabType["FREQUENTLY_BOUGHT_CAROUSEL"] = "FREQUENTLY_BOUGHT_CAROUSEL";
    ETabType["FAQ"] = "FAQ";
    ETabType["REVIEWS"] = "REVIEWS";
    ETabType["ECOSTRUXURE"] = "ECOSTRUXURE";
    ETabType["SUSTAINABILITY"] = "SUSTAINABILITY";
})(ETabType || (ETabType = {}));
const TABS_ORDER = [
    ETabType.DOCUMENTS,
    ETabType.COMPATIBLE_PRODUCTS,
    ETabType.SOFTWARE_CAROUSEL,
    ETabType.LIFECYCLE_CAROUSEL,
    ETabType.SPECIFICATIONS,
    ETabType.SUSTAINABILITY,
    ETabType.EPDS,
    ETabType.DDC_DOCUMENTS,
    ETabType.DDC_SOFTWARE,
    ETabType.EXPLORE_CAROUSEL,
    ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
    ETabType.FAQ,
    ETabType.REVIEWS,
];

var PesLinkEnum;
(function (PesLinkEnum) {
    PesLinkEnum["button"] = "button";
    PesLinkEnum["link"] = "link";
})(PesLinkEnum || (PesLinkEnum = {}));

var CountrySelectorConstants;
(function (CountrySelectorConstants) {
    CountrySelectorConstants["CS_ENDPOINT"] = "/{cc}/{lc}/download/download-api/getCountryLabels/";
    CountrySelectorConstants["COUNTRY_CODE"] = "ww";
    CountrySelectorConstants["LANGUAGE_CODE"] = "en";
    CountrySelectorConstants["APP_SOURCE"] = "SE";
    CountrySelectorConstants["NOT_SCOPED_MESSAGE"] = "The specified document is not available anywhere..";
    CountrySelectorConstants["TOGGLE_CLICK"] = "false";
})(CountrySelectorConstants || (CountrySelectorConstants = {}));

var REQUEST_SERVICE_EVENTS;
(function (REQUEST_SERVICE_EVENTS) {
    REQUEST_SERVICE_EVENTS["CONGIFURED"] = "configured";
})(REQUEST_SERVICE_EVENTS || (REQUEST_SERVICE_EVENTS = {}));
var REQUEST_ERROR_TYPES;
(function (REQUEST_ERROR_TYPES) {
    REQUEST_ERROR_TYPES["API_SETUP_TIMEOUT"] = "api-setup-timeout";
    REQUEST_ERROR_TYPES[REQUEST_ERROR_TYPES["RESOURCE_NOT_FOUND"] = 404] = "RESOURCE_NOT_FOUND";
    REQUEST_ERROR_TYPES[REQUEST_ERROR_TYPES["SERVER_FAILURE"] = 502] = "SERVER_FAILURE";
    REQUEST_ERROR_TYPES["DEFAULT"] = "default";
})(REQUEST_ERROR_TYPES || (REQUEST_ERROR_TYPES = {}));

export { ADD_TO_CART_EXCEPTION_CODES as A, BAZAAR_VOICE_URL as B, COMMERCIAL_STATUS_MAX_LENGTH as C, DEBOUNCED_HANDLER_DELAY as D, EAvailabilityType as E, DESKTOP_MAX_CONTENT_WIDTH as F, LOCALE_CODE_REGEX as L, NUMERIC_SEPARATOR as N, Protocol as P, REVIEW_SECTION_ANCHOR as R, SDL_REDESIGN_HEADER_SELECTOR as S, TAB_BAR_HEIGHT as T, URLS as U, EApcButtonType as a, b2cSiteTypeURLPrefix as b, SDL_HEADER_SELECTOR_APC as c, SDL_HEADER_SELECTOR as d, scrollBehavior as e, SLASH as f, CountrySelectorConstants as g, PRIMARY_BUTTONS as h, SECONDARY_BUTTONS as i, myProductsGroupType as j, EStatus as k, ENotificationType as l, myProductsResponseStatus as m, EEvent as n, ETabType as o, PLACEHOLDERS as p, EPromiseStatus as q, rangeBasePath as r, siteType as s, sustainabilityGroupNameSpryker as t, sustainabilityGroupNameAtg as u, ECustomerType as v, ECommercialStatus as w, APC_PRIMARY_BUTTONS as x, TABS_ORDER as y, PesLinkEnum as z };
